

























































































































































import { Vue, Component, Lifecycle, Prop, p } from "av-ts";
import { ITopic, IStudyRole, IRoleCount, IChartData,
    IOfferingRoleCount, IOfferingRoleWeights, IRecommendation } from "../../interfaces/models";
import AvailabilityService from "../../services/AvailabilityService";
import UserService from "../../services/UserService";
import TopicService from "../../services/TopicService";
import RecommendationService from "../../services/RecommendationService";
import Fetcher from "../../services/Fetcher";

import RecommendationCard from "./RecommendationCard.vue";

@Component({
    components: {
        RecommendationCard
    }
})
export default class RecommendationSearch extends Vue {
    @Prop
    topics = p<ITopic[]>({
        required: true
    });

    @Prop
    studyRoles = p<IStudyRole[]>({
        default: () => {
            return [];
        }
    });

    @Prop
    userRoles = p<Map<string, Map<string, boolean>>>({
        type: Map,
        default: () => {
            return new Map<string, Map<string, boolean>>();
        }
    });

    pShowRoles = true;
    competencies = new Map();
    pRoleWeights: IOfferingRoleWeights = {};
    pFindRecommendations: IRecommendation[] = [];

    get showRoles() {
        return this.pShowRoles;
    }
    set showRoles(newVal) {
        this.pShowRoles = newVal;
    }

    get recommendations() {
        return this.pFindRecommendations;
    }

    updateCompetencies(newCompetencies: IChartData) {
        let compMap = new Map<ITopic, Number>();
        for (let i = 0; i < newCompetencies.labels.length; i++) {
            compMap.set(TopicService.topicByName(newCompetencies.labels[i])!,
                newCompetencies.datasets[0].data[i]);
        }
        this.competencies = compMap;
        return compMap;
    };

    updateRoleWeights(newRoleCount: IOfferingRoleCount) {
        const roleCounts: [IRoleCount] = newRoleCount.counts;
        const max: number = newRoleCount.max;
        let roleWeightLookup: IOfferingRoleWeights = {};
        roleCounts.map(roleCount => {
            const { topic, studyRole, entries } = roleCount;
            if (roleWeightLookup[topic] === undefined) {
                // Create the lookup Table
                roleWeightLookup[topic] = { [studyRole]: entries / max };
            } else {
                roleWeightLookup[topic][studyRole] = entries / max;
            }
        });
        this.pRoleWeights = roleWeightLookup;
    };

    updateFindRecommendations(recommendations: IRecommendation[]) {
        this.pFindRecommendations = recommendations;
    };

    @Lifecycle
    created() {
        Fetcher.get(UserService.userCompetencies)
            .on(this.updateCompetencies);
        Fetcher.get(AvailabilityService.getOfferingRoleCount)
            .on(this.updateRoleWeights);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.userCompetencies)
            .off(this.updateCompetencies);
        Fetcher.get(AvailabilityService.getOfferingRoleCount)
            .off(this.updateRoleWeights);
    }

    checkbox(topic: ITopic, studyRole: IStudyRole): boolean {
        if (!this.userRoles.has(topic.name)) {
            return false;
        } else {
            const topicRoles = this.userRoles.get(topic.name);
            if (topicRoles !== undefined) {
                return topicRoles.get(studyRole.role) || false;
            }
            return false;
        }
    }

    checkboxChange(topic: ITopic, studyRole: IStudyRole) {
        this.$emit("change", topic.id, studyRole.id);
    }

    checkboxIsDisabled(sType: string, topic: ITopic) {
        if (sType == "Provide Mentorship") {
            const weight = this.competencies.get(topic);
            return weight === undefined || weight <= 1100;
        }

        return false;
    }

    getColour(c: number) {
        if (c < 1000) {
            return "rgba(255, 99, 132, ";
        } else if (c >= 1000 && c <= 1100) {
            return "rgba(255, 206, 86, ";
        } else if (c >= 1100) {
            return "rgba(34, 85, 102, ";
        }
    }

    getCellWeight(topic: ITopic) {
        const weight = this.competencies.get(topic);
        const width = (weight - 800) / 4;
        return {
            background: `${this.getColour(weight)}${0.4})`,
            borderColor: `${this.getColour(weight)}1)`,
            width: `${width}%`
        };
    }

    getCellShade(topic:ITopic, studyRole:IStudyRole) {
        if (this.pShowRoles) {
            let weight = 0;
            if (this.pRoleWeights[topic.id] !== undefined) {
                if (this.pRoleWeights[topic.id][studyRole.id] !== undefined) {
                    weight = this.pRoleWeights[topic.id][studyRole.id];
                }
            }

            // Perferably have a lookup table generated on mount
            return {
                background: `rgba(34, 85, 102, ${weight})`
            };
        }
    }

    updateRecommendation(id: number, status: string, location: string | undefined) {
        RecommendationService.updateUserStatus(id, status, location)
            .then(_ => RecommendationService.findRecommendations())
            .then(x => this.updateFindRecommendations(x));
    }

    recommendStudySessions() {
        RecommendationService.recommendStudySessions()
            .then(x => this.updateFindRecommendations(x));
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/peers/RecommendationSearch.vue